<template>
  <v-container class="pa-0 ma-0">
    <v-row id="float-panel">
      <v-col id="folder-select-section" cols="auto" align-self="center">
        <v-row>
          <v-col cols="auto" align-self="center">
            <v-btn fab color="rgba(0, 0, 0, 0.5)" small @click="previousFolder">
              <v-icon small color="white">
                mdi-less-than
              </v-icon>
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-select
                dense
                dark
                hide-details="auto"
                v-model="folderUuid"
                :items="folders"
                v-on:change="changeFolder"
            >
              <template v-slot:selection="data">
                <v-container class="py-0">
                  <v-row class="px-2">
                    {{ data.item.text.shooting_date ? data.item.text.shooting_date.split(' ')[0] : null }}
                  </v-row>
                  <v-row>
                    <v-chip
                        v-if="data.item.text.property.shooting_height"
                        x-small
                        class="ma-1"
                    >
                      {{ data.item.text.property.shooting_height }}m
                    </v-chip>
                    <v-chip
                        v-if="data.item.text.property.gimbal_angle"
                        x-small
                        class="ma-1"
                    >
                      {{ data.item.text.property.gimbal_angle }}°
                    </v-chip>
                    <v-chip
                        v-if="data.item.text.property.drone_type"
                        x-small
                        class="ma-1"
                    >
                      {{ data.item.text.property.drone_type }}
                    </v-chip>
                    <v-chip
                        v-if="
                      data.item.text.color_type == 'thermal' ||
                      data.item.text.color_type_count == 2
                    "
                        color="orange"
                        x-small
                        class="ma-1"
                    >
                      サーマル
                    </v-chip>
                    <v-chip
                        v-if="
                      data.item.text.color_type == 'color' ||
                      data.item.text.color_type_count == 2
                    "
                        color="green"
                        x-small
                        class="ma-1"
                    >
                      RGB
                    </v-chip>
                  </v-row>
                </v-container>
              </template>
              <template v-slot:item="data">
                <v-container>
                  <v-row class="px-2">
                    {{ data.item.text.shooting_date ? data.item.text.shooting_date.split(' ')[0] : null }}
                  </v-row>
                  <v-row>
                    <v-chip
                        v-if="data.item.text.property.shooting_height"
                        x-small
                        class="ma-1"
                    >
                      {{ data.item.text.property.shooting_height }}m
                    </v-chip>
                    <v-chip
                        v-if="data.item.text.property.gimbal_angle"
                        x-small
                        class="ma-1"
                    >
                      {{ data.item.text.property.gimbal_angle }}°
                    </v-chip>
                    <v-chip
                        v-if="data.item.text.property.drone_type"
                        x-small
                        class="ma-1"
                    >
                      {{ data.item.text.property.drone_type }}
                    </v-chip>
                    <v-chip
                        v-if="
                      data.item.text.color_type == 'thermal' ||
                      data.item.text.color_type_count == 2
                    "
                        color="orange"
                        x-small
                        class="ma-1"
                    >
                      サーマル
                    </v-chip>
                    <v-chip
                        v-if="
                      data.item.text.color_type == 'color' ||
                      data.item.text.color_type_count == 2
                    "
                        color="green"
                        x-small
                        class="ma-1"
                    >
                      RGB
                    </v-chip>
                  </v-row>
                </v-container>
              </template>
            </v-select>
          </v-col>
          <v-col cols="auto" align-self="center">
            <v-btn fab color="rgba(0, 0, 0, 0.5)" small @click="nextFolder">
              <v-icon small color="white">
                mdi-greater-than
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <div id="map-compare" v-if="folders.length > 0" @click="mapCompare">
        <v-col cols="auto" align-self="center">
          <v-icon color="white">
            mdi-select-compare
          </v-icon>
        </v-col>
        <v-col align-self="center" style="padding-top: 0; padding-bottom: 0;">
          <span style="font-size: small">比較</span>
        </v-col>
      </div>
    </v-row>
    <div id="map2d" ref="map2d"></div>
    <annotation-view-dialog
        v-model="showAnnotationViewDialog"
        v-if="showAnnotationViewDialog"
        :info="annotationInfo"
        @displayAnnotationImages="displayAnnotationImages"
    ></annotation-view-dialog>
    <image-view-dialog
        :info="imageInfo"
        v-model="showImageDialog"
        v-if="showImageDialog"
    ></image-view-dialog>
    <map-compare
        v-model="openMapCompare"
        v-if="openMapCompare"
        :folder-uuid="folderUuid"
        :getLayerById="getLayerById"
        :getNaviLayerByValue="getNaviLayerByValue"
        :layers="layers"
        :mapInitialPosition="mapInitialPosition"
        :folders="folders"
        :annotationSource="annotation.annotationLayer.getSource()"
    ></map-compare>
  </v-container>
</template>

<script>
import Annotation from "@/utils/annotation";
import TileLayer from "ol/layer/Tile";
import XYZ from "ol/source/XYZ";
import LayerGroup from "ol/layer/Group";
import OSM from "ol/source/OSM";
import {store} from "@/store";
import Map from "ol/Map";
import View from "ol/View";
import 'ol/ol.css';
import TileState from "ol/TileState";
import Coordinate from "@/utils/coordinate";
import AnnotationViewDialog from "@/components/dialog/AnnotationViewDialog";
import {toLonLat} from "ol/proj";
import ImageViewDialog from "@/components/dialog/ImageViewDialog";
import download from "downloadjs";
import MapCompare from "@/components/dialog/MapCompare";

export default {
  name: "MapView",
  components: {
    ImageViewDialog,
    AnnotationViewDialog,
    MapCompare
  },
  data(){
    return {
      map: null,
      annotation: new Annotation(),
      layers: null,
      mapInitialPosition: {
        bound_1_lng: 0,
        bound_1_lat: 0,
        bound_2_lng: 0,
        bound_2_lat: 0,
      },
      mapTab: store.state.mapTab,
      folders: [],
      folderUuid: this.$route.params.folderUuid,
      folder: null,
      originLonLatColorLayer: new Coordinate('origin_color'),
      calcLonLatColorLayer: new Coordinate('cal_color'),
      originLonLatThermalLayer: new Coordinate('origin_thermal'),
      calcLonLatThermalLayer: new Coordinate('cal_thermal'),

      annotationInfo: null,
      showAnnotationViewDialog: false,

      imageInfo: null,
      showImageDialog: false,

      filter: {
        panel_error_types: ['cell', 'multicell', 'cluster', 'module', 'string', 'junction', 'pid', 'shadow'],
        panel_error_reasons: ['undefined', 'crack', 'sediment', 'vegetation']
      },
      sharedState: store.state,
      breadcrumbs: [],
      openMapCompare: false
    }
  },

  methods: {
    initMap(){
      this.resetLayers();
      this.axios
          .get(`/api/map/${this.folderUuid}`)
          .then((response) => {
            this.folder = response.data.folder;
            this.setDDMapPlanToMap(this.layers, response.data);
            this.setCoordinate(response.data);
            this.$root.$emit('changeFolderMap');

            response.data.annotation.panel_abnormality.list.forEach(item => {
              this.$root.$emit('turnOnFilter', item.type);
            });

            store.updateMapviewBreadcrumbs([
              {
                text: "ダッシュボード",
                disabled: false,
                exact: true,
                to: "/dashboard"
              },
              {
                text: this.folder.plant.name,
                disabled: false,
                exact: true,
                to: "/site/" + response.data.report.uuid
              },
              {
                text: 'マップ',
                disabled: false,
                exact: true,
                to: "/map/" + this.folder.uuid
              },
              {
                text: response.data.report.shooting_date,
                disabled: false,
                exact: true,
                to: "/map/" + this.folder.uuid
              },
            ]);

            this.map = new Map({
              target: this.$refs.map2d,
              layers: [
                this.annotation.annotationLayer,
                new TileLayer({
                  id: 'thermal',
                  zIndex: 3,
                  opacity: this.getNaviLayerByValue('thermal', this.layers).transparency,
                  title: "サーマルオルソ画像",
                  visible: this.getNaviLayerByValue('thermal', this.layers).visible,
                  extent: [
                    this.getNaviLayerByValue('thermal', this.layers).bound1Lng,
                    this.getNaviLayerByValue('thermal', this.layers).bound1Lat,
                    this.getNaviLayerByValue('thermal', this.layers).bound2Lng,
                    this.getNaviLayerByValue('thermal', this.layers).bound2Lat,
                  ],
                  source: new XYZ({
                    maxZoom: this.getNaviLayerByValue('thermal', this.layers).maxZoom,
                    minZoom: 17,
                    attributions: "",
                    url: this.getNaviLayerByValue('thermal', this.layers).mapUrl,
                    tileSize: [256, 256],
                  }),
                }),
                new TileLayer({
                  id: 'color',
                  zIndex: 2,
                  opacity: this.getNaviLayerByValue('color', this.layers).transparency,
                  visible: this.getNaviLayerByValue('color', this.layers).visible,
                  title: "RGBオルソ画像",
                  extent: [
                    this.getNaviLayerByValue('color', this.layers).bound1Lng,
                    this.getNaviLayerByValue('color', this.layers).bound1Lat,
                    this.getNaviLayerByValue('color', this.layers).bound2Lng,
                    this.getNaviLayerByValue('color', this.layers).bound2Lat,
                  ],
                  source: new XYZ({
                    maxZoom: this.getNaviLayerByValue('color', this.layers).maxZoom,
                    minZoom: 17,
                    attributions: "",
                    url: this.getNaviLayerByValue('color', this.layers).mapUrl,
                    tileSize: [256, 256],
                  }),
                }),
                new LayerGroup({
                  id: 'basic',
                  layers: [
                    new TileLayer({
                      id: 'Satellite',
                      zIndex: 1,
                      title: "Satellite",
                      opacity: this.getNaviLayerByValue('basic', this.layers).satellite.transparency,
                      visible: this.getNaviLayerByValue('basic', this.layers).satellite.visible,
                      source: new OSM({
                        minZoom: 17,
                        maxZoom: 17,
                        url: '/api/tiles/{z}/{x}/{y}',
                        tileLoadFunction: (tile, src) => {
                          const xhr = new XMLHttpRequest();
                          xhr.responseType = 'blob';
                          xhr.addEventListener('loadend', function () {
                            const data = this.response;
                            if (data !== undefined) {
                              tile.getImage().src = URL.createObjectURL(data);
                            } else {
                              tile.setState(TileState.ERROR);
                            }
                          });
                          xhr.addEventListener('error', function () {
                            tile.setState(TileState.ERROR);
                          });
                          xhr.open('GET', src);
                          xhr.setRequestHeader('Authorization', `Bearer ${store.state.token}`);
                          xhr.send();
                        }
                      }),
                    }),
                    new TileLayer({
                      id: 'OpenStreetMap',
                      zIndex: 0,
                      title: "OpenStreetMap",
                      opacity: this.getNaviLayerByValue('basic', this.layers).openStreetMap.transparency,
                      visible: this.getNaviLayerByValue('basic', this.layers).openStreetMap.visible,
                      source: new OSM(),
                    }),
                  ]
                })
              ],

              view: new View({
                maxZoom: 23,
                zoom: 17,
                center: [
                  (this.mapInitialPosition.bound_1_lng +
                      this.mapInitialPosition.bound_2_lng) /
                  2,
                  (this.mapInitialPosition.bound_1_lat +
                      this.mapInitialPosition.bound_2_lat) /
                  2,
                ],
              }),
            });
            const mapExtent = [
              this.mapInitialPosition.bound_1_lng - 1000,
              this.mapInitialPosition.bound_1_lat - 1000,
              this.mapInitialPosition.bound_2_lng + 1000,
              this.mapInitialPosition.bound_2_lat + 1000,
            ];

            const screenExtent = this.map.getView().calculateExtent();
            mapExtent.forEach((position, index) => {
              if (position < screenExtent[index] && index >= 2) {
                mapExtent[index] = screenExtent[index];
              }
              if (position > screenExtent[index] && index <= 1) {
                mapExtent[index] = screenExtent[index];
              }
            });

            this.map.setView(new View({
              maxZoom: 23,
              zoom: 17,
              center: [
                (this.mapInitialPosition.bound_1_lng +
                    this.mapInitialPosition.bound_2_lng) /
                2,
                (this.mapInitialPosition.bound_1_lat +
                    this.mapInitialPosition.bound_2_lat) /
                2,
              ],
              extent: mapExtent,
            }));

            this.map.getView().setZoom(18);
            this.map
                .getView()
                .fit([
                  this.mapInitialPosition.bound_1_lng,
                  this.mapInitialPosition.bound_1_lat,
                  this.mapInitialPosition.bound_2_lng,
                  this.mapInitialPosition.bound_2_lat,
                ]);

            this.annotation.init(this.map, response.data.annotation);

            this.map.on('click', (evt) => {
              if (!this.getNaviLayerByValue('annotation', this.layers).visible) return;
              this.annotation.annotationLayer
                  .getFeatures(evt.pixel)
                  .then((features) => {
                    const feature = features.length ? features[0] : undefined;
                    if (feature) {
                      let thermalImages = [];
                      let colorImages = [];
                      if(this.folder.app !== 'airprobe'){
                        thermalImages = this.getImages(this.originLonLatThermalLayer.layer, feature);
                        colorImages = this.getImages(this.originLonLatColorLayer.layer, feature);
                      }
                      else{
                        thermalImages = this.getAPImages(this.calcLonLatThermalLayer.layer, feature, 'thermal');
                        colorImages = this.getAPImages(this.calcLonLatColorLayer.layer, feature, 'color');
                      }

                      this.annotationInfo = {
                        id: feature.getId(),
                        type: feature.get("type"),
                        reason: feature.get("reason"),
                        coordinates: toLonLat(feature.getGeometry().getCoordinates()),
                        thermalImages: thermalImages,
                        colorImages: colorImages,
                      };
                      // this.clickedAnnotation = feature;
                      this.showAnnotationViewDialog = true;
                      this.annotation.mode = "edit";
                      // this.selectedAnnotation = feature;
                    }
                    else {
                      this.selectedAnnotation = null;
                    }
                  });
            })
          })
    },
    setCoordinate(ddMapPlan){
      if((ddMapPlan["color_coordinate"])){
        this.orign_photos_color = ddMapPlan["color_coordinate"]["coordinate"];
        this.cal_photos_color = ddMapPlan["color_coordinate"]["coordinate_cal"];
        this.originLonLatColorLayer.setLayer(this.orign_photos_color, 2, 5);
        this.calcLonLatColorLayer.setLayer(this.cal_photos_color, 1, 5);
        // this.displayOrigin(this.getNaviLayerByValue('coordinate_color', this.layers));
      }
      if((ddMapPlan["thermal_coordinate"])){
        this.orign_photos_thermal = ddMapPlan["thermal_coordinate"]["coordinate"];
        this.cal_photos_thermal = ddMapPlan["thermal_coordinate"]["coordinate_cal"];
        this.originLonLatThermalLayer.setLayer(this.orign_photos_thermal, 4, 6);
        this.calcLonLatThermalLayer.setLayer(this.cal_photos_thermal, 3, 6);
        // this.displayOrigin(this.getNaviLayerByValue('coordinate_thermal', this.layers));
      }
    },
    initFolders() {
      this.axios
          .get(`/api/folder/get-folder-list/${this.folderUuid}`)
          .then((response) => {
            const folders = response.data;
            folders.forEach((folder) => {
              if (folder.property.shooting_height) {
                folder.property.shooting_height = folder.property.shooting_height.toString();
                folder.property.shooting_height = folder.property.shooting_height.split('M')[0];
              }
              this.folders.push({value: folder.uuid, text: folder});
              if (folder.uuid === this.folderUuid) {
                this.folderUuid = folder.uuid;
              }
            });
          });
    },
    resetLayers(){
      this.layers = [
        {
          text: "アノテーション",
          value: "annotation",
          transparency: 100,
          visible: true,
        },
        {
          text: "サーマルオルソ画像",
          value: "thermal",
          transparency: 100,
          visible: false,
          mapUrl: "",
          bound1Lng: 0,
          bound1Lat: 0,
          bound2Lng: 0,
          bound2Lat: 0,
          lat_translate: 0,
          lng_translate: 0,
          maxZoom: null,
        },
        {
          text: "RGBオルソ画像",
          value: "color",
          transparency: 100,
          visible: false,
          mapUrl: "",
          bound1Lng: 0,
          bound1Lat: 0,
          bound2Lng: 0,
          bound2Lat: 0,
          lat_translate: 0,
          lng_translate: 0,
          maxZoom: null,
        },
        {
          openStreetMap: {
            transparency: 100,
            visible: true,
            text: "OpenStreetMap",
            value: 'OpenStreetMap',
          },
          satellite: {
            transparency: 100,
            visible: true,
            text: "Mapbox",
            value: 'Satellite',
          },
          visible: true,
          text: "ベースマップ",
          value: "basic",
        },
      ];
    },
    getNaviLayerByValue(value, layers){
      for (const layer of layers){
        if (layer.value === value){
          return layer;
        }
      }
      return null;
    },
    setDDMapPlanToMap(layer, ddMapPlan) {
      let colorType = [];
      if (ddMapPlan["color"]) {
        this.setMapLayerLocation(this.getNaviLayerByValue('color', layer), ddMapPlan["color"]);
        colorType.push("color");
        this.mapInitialPosition = JSON.parse(JSON.stringify(ddMapPlan["color"]));
      }
      if (ddMapPlan["thermal"]) {
        this.setMapLayerLocation(this.getNaviLayerByValue('thermal', layer), ddMapPlan["thermal"]);
        colorType.push("thermal");
        if (!this.mapInitialPosition.bound_1_lng){
          this.mapInitialPosition = JSON.parse(JSON.stringify(ddMapPlan["thermal"]));
        }
      }
      if (colorType.includes('thermal')){
        this.getNaviLayerByValue('thermal', layer).visible = true;
        this.getNaviLayerByValue('color', layer).visible = false;
      }
      else {
        this.getNaviLayerByValue('thermal', layer).visible = false;
        this.getNaviLayerByValue('color', layer).visible = true;
      }

      store.updateSideBar(colorType);
    },
    setMapLayerLocation(layer, ddMapPlan) {
      layer.mapUrl = ddMapPlan.path;
      layer.bound1Lng = ddMapPlan.bound_1_lng;
      layer.bound1Lat = ddMapPlan.bound_1_lat;
      layer.bound2Lng = ddMapPlan.bound_2_lng;
      layer.bound2Lat = ddMapPlan.bound_2_lat;
      layer.lat_translate = ddMapPlan.lat_translate;
      layer.lng_translate = ddMapPlan.lng_translate;
      layer.maxZoom = ddMapPlan.max_zoom;
    },
    getLayerById(id, fromLayer){
      const layers = fromLayer.getLayers().getArray();
      for (const layer of layers) {
        if (layer.get("id") === id){
          return layer;
        }
        else{
          if (layer instanceof LayerGroup){
            const a = this.getLayerById(id, layer);
            if (a) return a;
          }
        }
      }
      return null;
    },
    calculateDistance(a, b){
      return Math.sqrt(Math.pow(a[0]-b[0], 2) + Math.pow(a[1]-b[1], 2));
    },
    getImages(layer, feature){
      const array = layer.getSource().getFeatures();
      array.sort((a, b) => {
        return this.calculateDistance(feature.getGeometry().getCoordinates(), a.getGeometry().getCoordinates()) - this.calculateDistance(feature.getGeometry().getCoordinates(), b.getGeometry().getCoordinates());
      });
      return array.slice(0, 4).map((image) => {
        // let filtered = image.get('filtered');
        // if (image.get('filtered') === undefined || image.get('filtered') === null){
        //   filtered = false;
        // }
        return {
          src: image.get('name'),
          distance: this.calculateDistance(feature.getGeometry().getCoordinates(), image.getGeometry().getCoordinates())
        };
      });
    },
    getAPImages(layer, feature, color_type){
      if (feature.get(`airprobe_${color_type}_image`)){
        const array = layer.getSource().getFeatures();
        if (array.length > 0){
          array.sort((a, b) => {
            return a.get('name').localeCompare(b.get('name'))
          });
          let feature_name = feature.get(`airprobe_${color_type}_image`);
          for (let i = 0; i < array.length; i++) {
            const array_name = array[i].get('name').split(/[\\/]/).pop().split('.')[0];
            if(feature_name.includes(array_name)){
              let min = i - 2;
              let max = i + 2;
              if (min < 0){
                min = 0;
                max = 4;
              }
              if (max > array.length){
                max = array.length;
                min = max - 4;
              }
              return array.slice(min, max).map((image) => {
                let filtered = image.get('filtered');
                if (image.get('filtered') === undefined || image.get('filtered') === null){
                  filtered = false;
                }
                return {src: image.get('name'), rotate: image.get('rotate'), crop: image.get('crop'),
                  annotation_mark: image.get('annotation_mark'), type: 'airprobe',
                  filtered: filtered,
                  distance: this.calculateDistance(feature.getGeometry().getCoordinates(), image.getGeometry().getCoordinates())};
              });
            }
          }
        }
      }
      return this.getImages(layer, feature);
    },
    previousFolder() {
      const folders = this.folders;
      const currentPos = folders.findIndex((folder) => {
        return folder.value === this.folderUuid;
      });
      if (currentPos !== folders.length - 1) {
        this.folderUuid = folders[currentPos + 1].value;
        this.changeFolder();
      }
    },
    nextFolder() {
      const folders = this.folders;
      const currentPos = folders.findIndex((folder) => {
        return folder.value === this.folderUuid;
      });
      if (currentPos > 0) {
        this.folderUuid = folders[currentPos - 1].value;
        this.changeFolder();
      }
    },
    changeFolder(){
      this.$router.push({name: "MapView", params: {folderUuid: this.folderUuid}});
      this.resetLayers();
      this.originLonLatColorLayer.setLayer([], 2, 5);
      this.calcLonLatColorLayer.setLayer([], 1, 5);
      this.originLonLatThermalLayer.setLayer([], 4, 6);
      this.calcLonLatThermalLayer.setLayer([], 3, 6);
      this.showAnnotationViewDialog = false;
      this.axios
          .get(`/api/map/${this.folderUuid}`)
          .then((response) => {
            this.folder = response.data.folder;
            this.setDDMapPlanToMap(this.layers, response.data);
            this.setCoordinate(response.data);
            this.$root.$emit('changeFolderMap');

            store.updateMapviewBreadcrumbs([
              {
                text: "ダッシュボード",
                disabled: false,
                exact: true,
                to: "/dashboard"
              },
              {
                text: this.folder.plant.name,
                disabled: false,
                exact: true,
                to: "/site/" + response.data.report.uuid
              },
              {
                text: 'マップ',
                disabled: false,
                exact: true,
                to: "/map/" + this.folder.uuid
              },
              {
                text: response.data.report.shooting_date,
                disabled: false,
                exact: true,
                to: "/map/" + this.folder.uuid
              },
            ]);

            this.map
                .getView()
                .setCenter([
                  (this.mapInitialPosition.bound_1_lng +
                      this.mapInitialPosition.bound_2_lng) /
                  2,
                  (this.mapInitialPosition.bound_1_lat +
                      this.mapInitialPosition.bound_2_lat) /
                  2,
                ]);
            this.map
                .getView()
                .fit([
                  this.mapInitialPosition.bound_1_lng,
                  this.mapInitialPosition.bound_1_lat,
                  this.mapInitialPosition.bound_2_lng,
                  this.mapInitialPosition.bound_2_lat,
                ]);

            this.changeMapLayer(this.getLayerById('thermal', this.map), this.getNaviLayerByValue('thermal', this.layers));
            this.changeMapLayer(this.getLayerById('color', this.map), this.getNaviLayerByValue('color', this.layers));

            this.annotation.setSource(response.data.annotation);
          })
    },

    changeMapLayer(mapLayer, layer) {
      mapLayer.setSource(new XYZ({
        maxZoom: layer.maxZoom,
        minZoom: 17,
        attributions: "",
        url: layer.mapUrl,
        tileSize: [256, 256],
      }));
      mapLayer.setExtent([
        layer.bound1Lng,
        layer.bound1Lat,
        layer.bound2Lng,
        layer.bound2Lat,
      ]);
      mapLayer.setVisible(layer.visible);
      mapLayer.setOpacity(layer.transparency);
    },

    displayAnnotationImages(coord, listImage, position, imageType){
      const imageName = listImage[position].src.split('/');
      this.imageInfo = {
        long: coord[0],
        lat: coord[1],
        src: listImage[position].src,
        name: imageName[imageName.length - 1],
        list: listImage,
        currentIndex: position,
        type: imageType,
        // rotate: listImage[position].rotate,
        // crop: listImage[position].crop,
        // annotation_mark: listImage[position].annotation_mark,
        // app: listImage[position].type,
        // filtered: listImage[position].filtered
      }
      this.showImageDialog = true;
    },
    mapCompare(){
      this.openMapCompare = true;
    },

    updateMapTab(tab){
      if (tab === 'thermal'){
        this.getNaviLayerByValue('thermal', this.layers).visible = true;
        this.getLayerById('thermal', this.map).setVisible(true);
        this.getNaviLayerByValue('color', this.layers).visible = false;
        this.getLayerById('color', this.map).setVisible(false);
      }
      else {
        this.getNaviLayerByValue('thermal', this.layers).visible = false;
        this.getLayerById('thermal', this.map).setVisible(false);
        this.getNaviLayerByValue('color', this.layers).visible = true;
        this.getLayerById('color', this.map).setVisible(true);
      }
    },
    filterAnnotation(annotation_filter){
      const panelErrorTypes = annotation_filter;
      const panelErrorReasons = ['undefined', 'crack', 'sediment', 'vegetation'];
      this.filter.panel_error_types = annotation_filter;
      this.annotation.filter(panelErrorTypes, panelErrorReasons);
    },
    downloadOrtho(type){
      store.showLoadingOverlay(true);
      let fileName = 'アノテーション付き';
      if (type === 'thermal'){
        fileName = fileName + '_サーマルオルソ画像';
      }
      else {
        fileName = fileName + '_RGBオルソ画像';
      }
      const x=new XMLHttpRequest();
      x.open( "GET", '/api/folder/export-image/' + this.folderUuid + '/' + type + '?token=' + store.state.token + '&filter=' + JSON.stringify(this.filter), true);
      x.responseType="blob";
      x.onload= function(e){
        if (x.status === 200){
          download(e.target.response, fileName);
        }
        else {
          store.showErrorDialog('エラーが発生しました。再度試してください。');
        }
        store.showLoadingOverlay(false);
      };
      x.send();
    }
  },

  created() {
    this.initFolders();
    this.$root.$emit('changeFolderMap');
  },

  mounted() {
    this.initMap();
    this.$root.$on('updateMapTab', this.updateMapTab);
    this.$root.$on('filter', this.filterAnnotation);
    this.$root.$on('downloadOrtho', this.downloadOrtho);
  },

  beforeDestroy() {
    this.$root.$off("updateMapTab", this.updateMapTab);
    this.$root.$off("filter", this.filterAnnotation);
    this.$root.$off("downloadOrtho", this.downloadOrtho);
  },
}
</script>

<style scoped>
#map2d {
  width: auto;
  height: calc(100vh - 48px);
}
>>>.ol-zoom {
  top: auto;
  bottom: 0.5em;
}

#float-panel {
  position: absolute;
  top: 10px;
  left: 22px;
  z-index: 1;
  border-radius: 4px;
  color: white;
}

#folder-select-section {
  background: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  width: auto;
  padding-bottom: 0;
  padding-top: 0;
}

#float-download-panel{
  position: absolute;
  top: 10px;
  right: 35px;
  z-index: 1;
  border-radius: 4px;
  color: white;
}

#map-compare{
  width: auto;
  z-index: 90;
  margin-left: 10px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.8);
  padding-left: 5px;
  padding-right: 5px;
  height: 70px;
  cursor: pointer;
}
>>>.v-text-field .v-select__selections > input {
  width: 0px;
}
</style>
